export const deriveFileExtension = (fileName?: string) =>
  fileName?.includes(".")
    ? fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length)
    : "";
